// Shared car form fields component — values aligned with car.gr accepted enum values
export const FUEL_TYPES = [
  "Βενζίνη",
  "Πετρέλαιο",
  "Ηλεκτρικό",
  "Υβριδικό βενζίνη",
  "Υβριδικό πετρέλαιο",
  "Υβριδικό plug-in βενζίνη",
  "Υβριδικό plug-in πετρέλαιο",
  "Αέριο(lpg) - βενζίνη",
  "Φυσικό αέριο(cng) - βενζίνη",
  "Υδρογόνο",
  "Άλλο",
];
export const TRANSMISSIONS = ["Χειροκίνητο", "Αυτόματο", "Ημιαυτόματο"];
export const BODY_TYPES = [
  "Κόμπακτ / Hatchback",
  "Κάμπριο / Roadster",
  "Λιμουζίνα / Sedan",
  "Αγροτικό / Pickup",
  "Κουπέ-Σπόρ",
  "Suv / Crossover / 4x4",
  "Van / Mini Bus / Mpv",
  "Επαγγελματικό Επιβατικό",
  "Άλλο",
];
export const DRIVE_TYPES = ["FWD", "RWD", "4x4"];
export const COLORS = [
  "Άσπρο",
  "Ασημί",
  "Γκρι",
  "Μαύρο",
  "Μπλε",
  "Μπλε σκούρο",
  "Κόκκινο",
  "Κόκκινο σκούρο",
  "Πράσινο",
  "Καφέ",
  "Μπεζ",
  "Χρυσαφί",
  "Άλλο",
];
export const EXTERIOR_COLOR_TYPES = ["Μεταλλικό", "Μη μεταλλικό", "Mat", "Pearl"];
export const INTERIOR_TYPES = ["Δέρμα", "Δερματίνη", "Ύφασμα", "Συνδυασμός δέρμα/ύφασμα", "Alcantara", "Άλλο"];
export const NUMPLATES = [
  { value: "", label: "—" },
  { value: "even", label: "Ζυγός" },
  { value: "odd", label: "Μονός" },
  { value: "unknown", label: "Άγνωστο" },
  { value: "without", label: "Χωρίς πινακίδες" },
  { value: "historical", label: "Ιστορικό" },
];
export const OWNERS_OPTIONS = [
  { value: "0", label: "— Να μην αποστέλλεται —" },
  ...Array.from({ length: 10 }, (_, i) => ({ value: String(i + 1), label: String(i + 1) })),
];
export const STATUSES = [
  { value: "available", label: "Διαθέσιμο" },
  { value: "reserved", label: "Κρατημένο" },
  { value: "sold", label: "Πωλήθηκε" },
];

export function Field({ label, children, hint, required, error }) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className={`text-[10px] uppercase tracking-[0.15em] ${error ? "text-[#E60000] font-bold" : "text-[#4B5563]"}`}>
        {label} {required && <span className="text-[#E60000]">*</span>}
      </span>
      <div className={`flex flex-col gap-1.5 [&>*]:w-full ${error ? "[&_input]:!border-[#E60000] [&_select]:!border-[#E60000] [&_input]:!bg-[#FEF2F2] [&_select]:!bg-[#FEF2F2]" : ""}`}>
        {children}
      </div>
      {error && <span className="text-[10px] text-[#E60000] font-mono">Υποχρεωτικό για το car.gr</span>}
      {hint && <span className="text-[10px] text-[#4B5563] font-mono">{hint}</span>}
    </label>
  );
}

export function TextInput(props) {
  return (
    <input
      {...props}
      className={`px-3 py-2 border border-black/20 bg-white outline-none focus:border-[#0055FF] text-sm ${props.className || ""}`}
    />
  );
}

export function NumberInput(props) {
  return (
    <input
      type="number"
      {...props}
      className={`px-3 py-2 border border-black/20 bg-white outline-none focus:border-[#0055FF] text-sm font-mono ${props.className || ""}`}
    />
  );
}

export function Select({ options, ...props }) {
  return (
    <select
      {...props}
      className={`px-3 py-2 border border-black/20 bg-white outline-none focus:border-[#0055FF] text-sm ${props.className || ""}`}
    >
      {options.map((o) =>
        typeof o === "string" ? (
          <option key={o} value={o}>{o}</option>
        ) : (
          <option key={o.value} value={o.value}>{o.label}</option>
        )
      )}
    </select>
  );
}
